import { configureStore } from '@reduxjs/toolkit';
import sliceReducer from './features/redux-check/reduxSlice'
import translateSlice from './features/audio-recorder/asrSlice';
import loaderSlice from './features/loader/loaderSlice';
import authSlice from './features/auth/authSlice';
import chatSlice from './features/chat-page/chatSlice';
import ecChatSlice from './features/ec-chat-page/ecChatSlice';
export const store = configureStore({
    reducer: {
        counter: sliceReducer,
        asr: translateSlice,
        loader: loaderSlice,
        auth: authSlice,
        chat: chatSlice,
        ecChat: ecChatSlice
    },
})